import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

// Vue.component('apex-chart', VueApexCharts)


import CommonManage from './Pages/CommonManage.vue'

Vue.component('common-manage', CommonManage)

Vue.config.productionTip = false
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
